<template>
  <div class="custom-main custom-theme">
    <a-spin :spinning="loading" tip="正在保存员工信息,请稍候...">
      <a-row :gutter="{ xs: 8, sm: 16, md: 16}">
        <a-col :xs="0" :sm="1" :md="1" :lg="1" :xl="1" :xxl="1">&nbsp;</a-col>
        <a-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18" :xxl="18">
          <a-form :form="form" layout="horizontal">
            <a-card size="small" :bordered="false">
              <span slot="title" style="margin-left: 36px;">
                <span style="font-size: 16px; font-weight: bold;"><a-icon type="unordered-list" />&nbsp;&nbsp;基本信息</span>
              </span>
              <a-row>
                <a-col span="8">
                  <a-form-item :colon="false" label="员工姓名" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                    <a-input v-decorator="['name', { rules: [{ required: true, message: '员工姓名必须填写!' }] , initialValue: ''}]" placeholder="请填写员工姓名"/>
                  </a-form-item>
                </a-col>
                <a-col span="8">
                  <a-form-item :colon="false" label="性别" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                    <a-select v-decorator="['sex', {rules: [{ required: true, message: '员工性别必须选择!' }], initialValue: ''}]" placeholder="请选择员工性别">
                      <a-select-option v-for="(item, index) in init.sexes" :key="'s'+index" :value="item.name">{{item.value}}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col span="8">
                  <a-form-item :colon="false" label="身份证号" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                    <a-input v-decorator="['idcard', { rules: [{ required: true, message: '员工身份证号必须填写!' },{ pattern: '((^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}$)|(^\\d{6}(18|19|20)?\\d{2}(0[1-9]|1[012])(0[1-9]|[12]\\d|3[01])\\d{3}(\\d|[xX])$))',
          message: '员工身份证号格式错误'}], initialValue: '' }]" placeholder="请填写员工身份证号" @blur="onBlurIdcard"/>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col span="8">
                  <a-form-item :colon="false" label="所属科室" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                    <a-tree-select :tree-data="init.departments" v-decorator="['departmentId', {rules: [{ required: true, message: '员工所属科室必须选择!' }], initialValue: '' }]" placeholder="请选择员工所属科室">
                    </a-tree-select>
                  </a-form-item>
                </a-col>
                <a-col span="8">
                  <a-form-item :colon="false" label="学历" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                    <a-select v-decorator="['education', {rules: [{ required: false }], initialValue: 'UNDERGRADUATE'}]">
                      <a-select-option v-for="(item, index) in init.educations" :key="'e'+index" :value="item.name">{{item.value}}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col span="8">
                  <a-form-item :colon="false" label="是否全科医生" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                    <a-radio-group v-decorator="['general', { rules: [{ required: false }], initialValue: 0 }]">
                      <a-radio :value="1">是</a-radio>
                      <a-radio :value="0">否</a-radio>
                    </a-radio-group>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col span="8">
                  <a-form-item :colon="false" label="加入时间" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                    <a-date-picker v-decorator="['joinDate', {rules: [{ required: false }]}]" />
                  </a-form-item>
                </a-col>
                <a-col span="8">
                  <a-form-item :colon="false" label="职称" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                    <a-select v-decorator="['title', {rules: [{ required: false }], initialValue: 'DOCTOR'}]">
                      <a-select-option v-for="(item, index) in init.titles" :key="'t'+index" :value="item.name">{{item.value}}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col span="8">
                  <a-form-item :colon="false" label="职务" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                    <a-input v-decorator="['job', { rules: [{ required: false }], initialValue: '' }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col span="8">
                  <a-form-item :colon="false" label="手机号码" :label-col="{sm: 24, md: 12, lg: 10, xl: 10, xxl: 10 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                    <a-input v-decorator="['phone', { rules: [{ required: true, message: '手机号码必须填写!' }], initialValue: '' }]"/>
                  </a-form-item>
                </a-col>
                <a-col span="16">
                  <a-form-item :colon="false" label="是否以手机号码为账号同步注册登录账号信息" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                    <a-radio-group v-decorator="['accounted', { rules: [{ required: false }], initialValue: 1 }]">
                      <a-radio :value="1">是</a-radio>
                      <a-radio :value="0">否</a-radio>
                    </a-radio-group>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-card>
            <a-card size="small" :bordered="false">
              <span slot="title" style="margin-left: 36px;">
                <span style="font-size: 16px; font-weight: bold;"><a-icon type="file-image" />&nbsp;&nbsp;资质文件</span>
              </span>
              <a-row>
                <a-col :xxl="6" :xl="6" :lg="6" :md="6" :sm="12" :xs="24" style="justify-content: center;display:grid;">
                  <span style="margin-top: 12px; margin-bottom: 12px;text-align: center;">身份证(人像面)</span>
                  <a-upload class="gpws-pic" list-type="picture-card" :show-upload-list="false" @preview="(file)=>handlePicPreview(file, 'MIF')" :before-upload="beforePicUpload" :custom-request="(file)=>handleImgUpload(file, 'MIF')">
                    <img style="width: 125px; height: 125px;" v-if="((undefined != pics.mif && null != pics.mif && '' != pics.mif) || (undefined != record.mif && null != record.mif && '' != record.mif))" :src="record.mif||pics.mif" />
                    <div v-else>
                      <a-icon :type="'plus'" />
                      <div class="ant-upload-text">
                        身份证(人像面)
                      </div>
                    </div>
                  </a-upload>
                </a-col>
                <a-col :xxl="6" :xl="6" :lg="6" :md="6" :sm="12" :xs="24" style="justify-content: center;display:grid;">
                  <span style="margin-top: 12px; margin-bottom: 12px;text-align: center;">身份证(国徽面)</span>
                  <a-upload class="gpws-pic" list-type="picture-card" :show-upload-list="false" @preview="(file)=>handlePicPreview(file, 'MIB')" :before-upload="beforePicUpload" :custom-request="(file)=>handleImgUpload(file, 'MIB')">
                    <img style="width: 125px; height: 125px;" v-if="((undefined != pics.mib && null != pics.mib && '' != pics.mib) || (undefined != record.mib && null != record.mib && '' != record.mib))" :src="record.mib||pics.mib" />
                    <div v-else>
                      <a-icon :type="'plus'" />
                      <div class="ant-upload-text">
                        身份证(国徽面)
                      </div>
                    </div>
                  </a-upload>
                </a-col>
                <a-col :xxl="6" :xl="6" :lg="6" :md="6" :sm="12" :xs="24" style="justify-content: center;display:grid;">
                  <span style="margin-top: 12px; margin-bottom: 12px;text-align: center;">国家资格证书（红本）</span>
                  <a-upload class="gpws-pic" list-type="picture-card" :show-upload-list="false" @preview="(file)=>handlePicPreview(file, 'NVQ')" :before-upload="beforePicUpload" :custom-request="(file)=>handleImgUpload(file, 'NVQ')">
                    <img style="width: 125px; height: 125px;" v-if="((undefined != pics.nvq && null != pics.nvq && '' != pics.nvq) || (undefined != record.nvq && null != record.nvq && '' != record.nvq))" :src="record.nvq||pics.nvq" />
                    <div v-else>
                      <a-icon :type="'plus'" />
                      <div class="ant-upload-text">
                        国家资格证书
                      </div>
                    </div>
                  </a-upload>
                </a-col>
                <a-col :xxl="6" :xl="6" :lg="6" :md="6" :sm="12" :xs="24" style="justify-content: center;display:grid;">
                  <span style="margin-top: 12px; margin-bottom: 12px;text-align: center;">执业资格证书（绿本）</span>
                  <a-upload class="gpws-pic" list-type="picture-card" :show-upload-list="false" @preview="(file)=>handlePicPreview(file, 'PQC')" :before-upload="beforePicUpload" :custom-request="(file)=>handleImgUpload(file, 'PQC')">
                    <img style="width: 125px; height: 125px;" v-if="((undefined != pics.pqc && null != pics.pqc && '' != pics.pqc) || (undefined != record.pqc && null != record.pqc && '' != record.pqc))" :src="record.pqc||pics.pqc" />
                    <div v-else>
                      <a-icon :type="'plus'" />
                      <div class="ant-upload-text">
                        执业资格证书
                      </div>
                    </div>
                  </a-upload>
                </a-col>
              </a-row>
            </a-card>
            <a-card size="small" :bordered="false">
              <span slot="title" style="margin-left: 36px;">
                <span style="font-size: 16px; font-weight: bold;"><a-icon type="gitlab" />&nbsp;&nbsp;简介</span>
              </span>
              <a-row>
                <a-col :xxl="1" :xl="1" :lg="1" :md="0" :sm="0" :xs="0">&nbsp;</a-col>
                <a-col :xxl="22" :xl="22" :lg="22" :md="24" :sm="24" :xs="24">
                  <a-form-item>
                    <a-textarea  :auto-size="{ minRows: 10, maxRows:20 }" v-decorator="['about', { rules: [{ required: false }], initialValue: '' }]"/>
                  </a-form-item>
                </a-col>
                <a-col :xxl="1" :xl="1" :lg="1" :md="0" :sm="0" :xs="0">&nbsp;</a-col>
              </a-row>
            </a-card>
          </a-form>
          <div class="button-container" style="float:right;margin-right: 48px;">
            <div>
              <a-button type="primary" style="margin-left: 24px;" @click="saveDoctor">保存</a-button>
              <a-button icon="double-left" style="margin-left: 24px;" @click="goBack">返回</a-button>
            </div>
          </div>
        </a-col>
        <a-col :xs="0" :sm="5" :md="5" :lg="5" :xl="5" :xxl="5">&nbsp;</a-col>
      </a-row>
    </a-spin>
  </div>
</template>

<script>
import Vue from 'vue'
import hevueImgPreview from 'hevue-img-preview';
Vue.use(hevueImgPreview);
export default {
  name: "DoctorCreate",
  data() {
    return {
      loading:false,
      loadTip:'',
      current:{},
      form: this.$form.createForm(this),
      init:{
        sexes:[],
        departments:[],
        titles:[],
        educations:[]
      },
      record:{},
      pics: {mif:'', mib:'', nvq:'', pqc:''}
    }
  },
  mounted() {
    const self = this;
    this.current = JSON.parse(localStorage.getItem("curruser"));
    this.getSexes(function (res) {
      self.init.sexes = res;
    });
    this.getProfessionTitles({organType:this.current.organType}, function (res) {
      self.init.titles = res;
    });
    this.getEducations(function (res) {
      self.init.educations = res;
    });
    this.getDepartmentTree({params:{organId:this.current.organId}}, function (res) {
      res.forEach(function (e){
        self.init.departments.push({title:e.name, value:e.id, key:e.id, children:self.children(e)});
      });
    });
  },
  beforeCreate() {
    let data = [{
      text: "首页",
      path: ""
    },{
      text: "医院管理",
      path: ""
    },{
      text: "员工管理",
      path: ""
    },{
      text: "新增员工",
      path: ""
    }];
    this.$store.commit('updateBreadcrumb', data);
  },
  methods:{
    saveDoctor:function (){
      if(undefined == this.current.organId || null == this.current.organId || '' == this.current.organId){
        self.$message.error({content: '当前用户无执业机构.', duration: 2});
        return;
      }
      const self = this;
      this.form.validateFields((err, values) => {
        if(!err){
          let certificates=[];
          if(undefined != self.pics.mif && null != self.pics.mif && '' != self.pics.mif){
              certificates.push({type:'MIF', path:self.pics.mif});
          }
          if(undefined != self.pics.mib && null != self.pics.mib && '' != self.pics.mib){
            certificates.push({type:'MIB', path:self.pics.mib});
          }
          if(undefined != self.pics.nvq && null != self.pics.nvq && '' != self.pics.nvq){
            certificates.push({type:'NVQ', path:self.pics.nvq});
          }
          if(undefined != self.pics.pqc && null != self.pics.pqc && '' != self.pics.pqc){
            certificates.push({type:'PQC', path:self.pics.pqc});
          }
          let params = Object.assign(values, {organId:self.current.organId, general:(values.general =='1'), certificates : certificates});
          if(undefined != values.joinDate && null != values.joinDate && '' != values.joinDate){
            params.joinDate = self.formatDate(new Date(values.joinDate));
          }
          self.loading=true;
          self.$axios.post('/api/clinic/doctor/register', params).then(function(res){
            self.loading=false;
            if(res.msg.flag == 0){
              self.$message.success({content: '员工新增成功.', duration: 2});
              self.form.resetFields();
              self.record = {mif:'', mib:'', nvq:'', pqc:''};
              self.pics = {mif:'', mib:'', nvq:'', pqc:''};
            }else{
              self.$message.error({content: res.msg.message, duration: 2});
            }
          },function(res){
            self.loading=false;
          });
        }
      });
    },

    handlePicPreview:function(file, type) {
      if (!file.url && !file.preview) {
        file.preview = this.getBase64(file.originFileObj);
      }
      if(type=='MIF'){
        this.pics.mif = file.url || file.preview;
      }
      if(type=='MIB'){
        this.pics.mib = file.url || file.preview;
      }
      if(type=='NVQ'){
        this.pics.nvq = file.url || file.preview;
      }
      if(type=='PQC'){
        this.pics.pqc = file.url || file.preview;
      }
    },
    beforePicUpload:function(file){
      const self = this;
      const isLt = file.size / 1024 / 1024 < 1;
      if(!isLt){
        self.$message.error({content: '图片文件大小需少于1M.', duration: 2});
        return false;
      }
      return true;
    },
    handleImgUpload:function(src, type){
      const self = this;
      const isLt = src.file.size / 1024 / 1024 < 1;
      if(!isLt){
        self.$message.error({content: '图片文件大小少于1M.', duration: 2});
        return false;
      }
      let params = new FormData();
      params.append("file", src.file);
      this.loadTip='正在上传资质文件图片....';
      this.loading = true;
      this.$axios.post('/api/dmz/DOCTOR/file/upload', params, {headers: {
          'Content-Type': 'multipart/form-data'
        },timeout: 1000 * 60 * 15}).then(function(res){
        self.loading = false;
        if(res.msg.flag == 0){
          if(type=='MIF'){
            self.record.mif = res.biz.url;
            self.pics.mif = res.biz.path;
          }
          if(type=='MIB'){
            self.record.mib = res.biz.url;
            self.pics.mib = res.biz.path;
          }
          if(type=='NVQ'){
            self.record.nvq = res.biz.url;
            self.pics.nvq = res.biz.path;
          }
          if(type=='PQC'){
            self.record.pqc = res.biz.url;
            self.pics.pqc = res.biz.path;
          }
          self.discern(type, res.biz.path);
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      },function(){
        self.loading = false;
      });

      return false;
    },

    /**
     * 智能识别
     */
    discern:function(type, path){
      if(type=='MIF'){//身份证正面
        this.idcardFrontDiscern(path);
      }else if(type=='MIB'){//身份证反面
        //this.idcardBackDiscern(path);
      }
    },
    idcardFrontDiscern:function(path){
      let self = this;
      this.$axios.post('/api/dmz/idcard/discern/front',{path:path}).then(function(res){
        if(res.msg.flag == 0){
          self.form.setFieldsValue({
            name : res.biz.name,
            idcard : res.biz.idCard
          })

        }
      },function (err) {

      })
    },

    idcardBackDiscern:function(path){
      let self = this;
      this.$axios.post('/api/dmz/idcard/discern/back',{path:path}).then(function(res){
        if(res.msg.flag == 0){
          self.form.setFieldsValue({
            leaderStartDate : res.biz.startDate,
            leaderEndDate : res.biz.endDate
          })
        }
      },function (err) {

      })
    },

    businessLDiscern:function(path){
      let self = this;
      this.$axios.post('/api/dmz/business/license/discern',{path:path}).then(function(res){
        if(res.msg.flag == 0){
          self.form.setFieldsValue({
            name : res.biz.name,
            organCode : res.biz.registerNo,
            address : res.biz.address,
            organValidDate : res.biz.vaildDate||''
          })

        }
      },function (err) {

      })
    },

    getBase64:function(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    previewImg (imgUrl) {
      this.$hevueImgPreview({
        url: imgUrl,
        keyboard: true,
      });
    },
    children:function (e) {
      const self = this;
      let result =[];
      if(undefined != e.children && null != e.children && e.children.length > 0){
        e.children.forEach(function (m){
          result.push({title:m.name, value:m.id, key:m.id, children:self.children(m)});
        });
      }
      return result;
    },
    goBack:function (){
      this.$router.push({ path: '/layout/system/doctor'});
    },
    onBlurIdcard:function (){
      let idcard = this.form.getFieldValue('idcard');
      if(undefined != idcard && null != idcard && '' != idcard && (idcard.length == 18 || idcard.length == 15)){
        idcard = idcard.trim();
        let sex='';
        if (idcard.length == 18){
          if(parseInt(idcard.charAt(16))%2 == 0){
            sex ='FEMALE';
          }else{
            sex ='MALE';
          }
        }
        if (idcard.length == 15) {
          if(parseInt(idcard.charAt(14))%2 == 0){
            sex ='FEMALE';
          }else{
            sex ='MALE';
          }
        }
        this.form.setFieldsValue({'sex':sex});
      }
    }
  }
}
</script>

<style>
.gpws-pic .ant-upload.ant-upload-select-picture-card{
  width: 125px!important;
  height: 125px!important;
}
.gpws-pic .ant-upload.ant-upload-select-picture-card > .ant-upload{
  padding: 0px!important;
}

.gpws-descriptions {
  margin-left: 48px;
  margin-right: 48px;
  margin-top: 24px;
}
.gpws-descriptions .ant-descriptions-item-label {
  text-align: center!important;
}
@media screen and (min-width: 1200px) {
  .gpws-descriptions .ant-descriptions-item-label {
    width: 198px!important;
  }
}
</style>
